/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */

/**
 * Data type of the measurement unit
 */
export type UpdateMeasurementUnitDtoDataType = (typeof UpdateMeasurementUnitDtoDataType)[keyof typeof UpdateMeasurementUnitDtoDataType];

export const UpdateMeasurementUnitDtoDataType = {
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  PERCENTAGE: 'percentage',
} as const;
